var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v(" "+_vm._s(_vm.$t('no.account'))+" "),_c('router-link',{attrs:{"to":"/signup"}},[_vm._v(_vm._s(_vm.$t('signup')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }